import { NgModule } from '@angular/core';
import { AvatarDisplayModule } from './avatar-display/avatar-display.module';
import { AvatarUploaderModule } from './avatar-uploader/avatar-uploader.module';

@NgModule({
  exports: [AvatarDisplayModule, AvatarUploaderModule]
})
export class AvatarModule {}
